$(document).ready(function(){
    $('.parallax').parallax();
});


// WEBPACK FOOTER //
// ./js/partials/parallax.js